import { CopyToClipboard } from 'react-copy-to-clipboard';

import { useOpenNotification } from 'utils/antd/notification-toasts';

import { CopyIcon } from '@atoms/Icon/CopyIcon';

import { EXPORT_KEY_COPY_TEST_ID, EXPORT_KEY_PEM_TEST_ID } from './constants';

type PemViewerProps = {
  label: string;
  content: string;
};

export const PemViewer = ({ label, content }: PemViewerProps) => {
  const openNotification = useOpenNotification();
  const lines = content.split('\n');

  return (
    <div className="flex flex-col gap-1 rounded-xl bg-surface-muted p-1.5">
      <div className="flex items-center gap-2.5 px-3 py-2">
        <span className="flex-1 text-sm font-medium leading-[18px] text-content-primary">
          {label}
        </span>
        <CopyToClipboard
          text={content}
          onCopy={() =>
            openNotification({
              kind: 'success',
              message: `${label} copied to your clipboard`
            })
          }
        >
          <button
            type="button"
            aria-label={`Copy ${label}`}
            data-testid={EXPORT_KEY_COPY_TEST_ID}
            className="cursor-pointer appearance-none border-0 bg-transparent p-0 text-content-primary"
          >
            <CopyIcon width={16} height={16} stroke="auto" />
          </button>
        </CopyToClipboard>
      </div>
      <pre
        data-testid={EXPORT_KEY_PEM_TEST_ID}
        className="overflow-x-auto rounded-xl bg-surface-muted p-3 font-mono text-xs leading-[23px]"
      >
        {lines.map((line, i) => (
          <div key={i} className="flex gap-2">
            <span className="w-4 shrink-0 select-none text-right text-content-secondary">
              {i + 1}
            </span>
            <code className="whitespace-pre text-content-strong">{line}</code>
          </div>
        ))}
      </pre>
    </div>
  );
};
